module.exports = __webpack_public_path__ + "5d3ecc721ec79434c3fc759d5a8e290b.svg";